import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { alpha, useTheme } from '@mui/material/styles';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { useResponsive } from 'src/hooks/use-responsive';
import { useConfig } from 'src/context/ConfigContext';

// import { bgGradient } from 'src/theme/css';
import { useAuthContext } from 'src/auth/hooks';
import { useTranslate } from 'src/locales';

// import Logo from 'src/components/logo';
// import EmblaCarousel from './embla-carousel';
import { Icon } from '@iconify/react';
import ParkCityLogo from 'src/components/logo/logo_new';
import Carousel from './embla-carousel';

// ----------------------------------------------------------------------

// const METHODS = [
//   {
//     id: 'jwt',
//     label: 'Jwt',
//     path: paths.auth.jwt.login,
//     icon: '/assets/icons/auth/ic_jwt.svg',
//   },
//   {
//     id: 'firebase',
//     label: 'Firebase',
//     path: paths.auth.firebase.login,
//     icon: '/assets/icons/auth/ic_firebase.svg',
//   },
//   {
//     id: 'amplify',
//     label: 'Amplify',
//     path: paths.auth.amplify.login,
//     icon: '/assets/icons/auth/ic_amplify.svg',
//   },
//   {
//     id: 'auth0',
//     label: 'Auth0',
//     path: paths.auth.auth0.login,
//     icon: '/assets/icons/auth/ic_auth0.svg',
//   },
//   {
//     id: 'supabase',
//     label: 'Supabase',
//     path: paths.auth.supabase.login,
//     icon: '/assets/icons/auth/ic_supabase.svg',
//   },
// ];

export type AuthClassicLayoutProps = {
  title?: string;
  image?: string;
  children: React.ReactNode;
};

export function AuthClassicLayout({ children, image, title }: AuthClassicLayoutProps) {
  // const { method } = useAuthContext();
  const { configData } = useConfig();

  // console.log(configData, 'configData');

  const { t } = useTranslate('sign-in');

  const theme = useTheme();
  // console.log(theme, 'theme');

  const mdUp = useResponsive('up', 'md');

  const renderLogo = (
    <Box
      sx={{
        position: 'absolute',
        top: '10px',
        left: '10px',
        height: '3rem',
      }}
    >
      <ParkCityLogo />
    </Box>
  );

  const slides = [
    {
      component: (
        <Box>
          <Typography
            sx={{
              fontSize: '4vw',
              fontWeight: 'light',
              color: '#F0EFF4',
            }}
          >
            {t('carousel.slide1.line1')}{' '}
            <Typography
              sx={{
                fontSize: '4vw',
                fontWeight: '700',
                color: '#F0EFF4',
              }}
            >
              {t('carousel.slide1.line2')}{' '}
            </Typography>
            {t('carousel.slide1.line3')}
          </Typography>
        </Box>
      ),
      scrollOnLearnMore: true,
      learnMoreContent: t('carousel.slide1.learnMore'),
    },
    {
      component: (
        <Box
          maxWidth="35vw"
          sx={{
            // bgcolor: { md: 'green', lg: 'blue' },
            display: 'flex',
            flexDirection: 'column',
            gap: '2.5em',
            borderLeftColor: '#F0EFF4',
            borderLeftWidth: '3px',
            borderLeftStyle: 'solid',
            padding: '2.5em',
            color: '#F0EFF4',
            backdropFilter: 'blur(30px)',
            borderRadius: '20px',
          }}
        >
          <Typography fontSize="1.302vw">{t('carousel.slide2.para1')}</Typography>
          <Typography fontSize="1.302vw">
            {t('carousel.slide2.para2')}{' '}
            <Link target="_blank" href={configData?.app_config?.QUALIFICATIONS} color="#FFD400">
              {t('carousel.slide2.link1')}
            </Link>
          </Typography>
          <Typography fontSize="1.302vw">
            {t('carousel.slide2.para3')}{' '}
            <Link target="_blank" href={configData?.app_config?.PROJECT_WEBPAGE} color="#FFD400">
              {t('carousel.slide2.link2')}{' '}
            </Link>
            {t('carousel.slide2.para4')}{' '}
            <Link target="_blank" href={configData?.app_config?.SALES_WEBPAGE} color="#FFD400">
              {t('carousel.slide2.link3')}
            </Link>
            .
          </Typography>
        </Box>
      ),
      // backgroundImage: 'https://via.placeholder.com/400x600/ff0000',
    },
  ];

  const renderContent = (
    <Stack
      sx={{
        bgcolor: theme.palette.background.paper,
        width: 1,
        mx: 'auto',
        maxWidth: 480,
        px: { xs: 2, md: 8 },
        // pt: { xs: 15, md: 20 },
        pb: { xs: 15, md: 0 },
      }}
    >
      {children}
    </Stack>
  );

  const renderSection = (
    <Stack
      flexGrow={1}
      spacing={10}
      alignItems="flex-start"
      justifyContent="center"
      sx={{
        // ...bgGradient({
        //   color: alpha(
        //     theme.palette.background.default,
        //     theme.palette.mode === 'light' ? 0.88 : 0.94
        //   ),
        //   imgUrl: '/assets/background/overlay_2.jpg',
        // }),
        backgroundImage:
          theme.palette.mode === 'light'
            ? `url('/assets/background/mountains_bg_light.png')`
            : `url('/assets/background/mountains_bg.png')`,
        backgroundSize: 'cover', // To ensure the image covers the entire stack
        backgroundPosition: 'center', // Centers the image
        backgroundRepeat: 'no-repeat', // Prevents the image from repeating
      }}
    >
      {/* <Typography variant="h3" sx={{ maxWidth: 480, textAlign: 'left' }}>
        {title || 'Hi, Welcome back'}
      </Typography> */}

      {/* <Box
        component="img"
        alt="auth"
        src={image || '/assets/illustrations/illustration_dashboard.png'}
        sx={{
          maxWidth: {
            xs: 480,
            lg: 560,
            xl: 720,
          },
        }}
      /> */}

      <Box width="100%" height="100vh">
        <Carousel slides={slides} />
      </Box>

      {/* <Stack direction="row" spacing={2}>
        {METHODS.map((option) => (
          <Tooltip key={option.label} title={option.label}>
            <Link component={RouterLink} href={option.path}>
              <Box
                component="img"
                alt={option.label}
                src={option.icon}
                sx={{
                  width: 32,
                  height: 32,
                  ...(method !== option.id && {
                    filter: 'grayscale(100%)',
                  }),
                }}
              />
            </Link>
          </Tooltip>
        ))}
      </Stack> */}
    </Stack>
  );

  return (
    <Stack
      component="main"
      direction="row"
      sx={{
        minHeight: '100vh',
      }}
    >
      {renderLogo}

      {mdUp && renderSection}

      {renderContent}
    </Stack>
  );
}
